import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=3c5b7e08&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=3c5b7e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b7e08",
  null
  
)

export default component.exports